export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

// Unfortunately date-fns-tz isn't compatible with the version of date-fns used in the project,
// so we implement a simple UTC date formatter manually.
export const formatDate = (date: Date, formatString = 'MMM DD'): string => {
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  if (formatString === 'MMM DD') {
    const month = monthNames[utcDate.getUTCMonth()];
    const day = utcDate.getUTCDate().toString().padStart(2, '0');
    return `${month} ${day}`;
  }

  return utcDate.toISOString().split('T')[0];
};
